import { useMutation } from 'react-query'

// Services
import { DeleteDocument } from 'services/api/Ai'

export default () => {
  const {
    mutate: deleteDocument,
    data: deleteDocumentData,
    error: deleteDocumentError,
    isLoading: isDeleteDocumentLoading,
    isSuccess: isDeleteDocumentSuccess,
    isError: isDeleteDocumentError,
  } = useMutation(DeleteDocument)

  return {
    deleteDocument,
    deleteDocumentData,
    deleteDocumentError,
    isDeleteDocumentLoading,
    isDeleteDocumentSuccess,
    isDeleteDocumentError,
  }
}
